import {
  Home_Icon,
  Reporting_Icon,
  Signout_Icon,
} from "../assets";

export const managementNav = [
  {
    icon: "",
    imgUrl: Home_Icon,
    title: "Home",
    path: "/home",
  },
  {
    icon: "",
    imgUrl: Reporting_Icon,
    title: "Reporting",
    path: "/report",
  },
  {
    icon: null,
    imgUrl: Signout_Icon,
    title: "Sign out",
    path: "/",
  },
];
